import React from 'react'

export default function Play({ isMobile }: { isMobile: boolean }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? "30" : '40'} height={isMobile ? "30" : '40'} viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="19" stroke="white" strokeWidth="2" />
            <path d="M25.7778 20L15.7778 26.5433L15.7778 13.4567L25.7778 20Z" fill="white" />
        </svg>
    )
}
